/**
 * @source https://github.com/mourner/simplify-js
 */
export class Path {
    private static getSqDist(p1: e5.IPoint, p2: e5.IPoint) {

        var dx = p1.x - p2.x,
            dy = p1.y - p2.y;

        return dx * dx + dy * dy;
    }

    // square distance from a point to a segment
    private static getSqSegDist(p: e5.IPoint, p1: e5.IPoint, p2: e5.IPoint) {

        var x = p1.x,
            y = p1.y,
            dx = p2.x - x,
            dy = p2.y - y;

        if (dx !== 0 || dy !== 0) {

            var t = ((p.x - x) * dx + (p.y - y) * dy) / (dx * dx + dy * dy);

            if (t > 1) {
                x = p2.x;
                y = p2.y;

            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }

        dx = p.x - x;
        dy = p.y - y;

        return dx * dx + dy * dy;
    }
    // rest of the code doesn't care about point format

    // basic distance-based simplification
    private static simplifyRadialDist(points: e5.IPoint[], sqTolerance: number) {

        var prevPoint = points[0],
            newPoints = [prevPoint],
            point;

        for (var i = 1, len = points.length; i < len; i++) {
            point = points[i];

            if (this.getSqDist(point, prevPoint) > sqTolerance) {
                newPoints.push(point);
                prevPoint = point;
            }
        }

        if (prevPoint !== point) newPoints.push(point);

        return newPoints;
    }

    private static simplifyDPStep(points: e5.IPoint[], first: number, last: number, sqTolerance: number, simplified: e5.IPoint[]) {
        var maxSqDist = sqTolerance,
            index;

        for (var i = first + 1; i < last; i++) {
            var sqDist = this.getSqSegDist(points[i], points[first], points[last]);

            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }

        if (maxSqDist > sqTolerance) {
            if (index - first > 1) this.simplifyDPStep(points, first, index, sqTolerance, simplified);
            simplified.push(points[index]);
            if (last - index > 1) this.simplifyDPStep(points, index, last, sqTolerance, simplified);
        }
    }

    // simplification using Ramer-Douglas-Peucker algorithm
    private static simplifyDouglasPeucker(points: e5.IPoint[], sqTolerance: number) {
        var last = points.length - 1;

        var simplified = [points[0]];
        this.simplifyDPStep(points, 0, last, sqTolerance, simplified);
        simplified.push(points[last]);

        return simplified;
    }

    public static toSvgPathData(points: e5.IPoint[]): string {
        var pathData = "";
        for (var i = 0; i < points.length; ++i) {
            if (i === 0) {
                pathData += `M ${points[i].x} ${points[i].y}`;
            } else {
                pathData += `L ${points[i].x} ${points[i].y}`;
            }
        }
        return pathData;
    }

    // both algorithms combined for awesome performance
    public static simplify(points: e5.IPoint[], tolerance: number = 1, highestQuality: boolean = false) {

        if (points.length <= 2) return points;

        var sqTolerance = tolerance * tolerance;

        // var inL = points.length;
        points = highestQuality ? points : this.simplifyRadialDist(points, sqTolerance);
        points = this.simplifyDouglasPeucker(points, sqTolerance);
        // console.log("SIMPLIFIED", inL, points.length);

        return points;
    }
}